import React, { useState } from 'react';
import NewBatch from '../../components/SchoolFees/NewBatch';
import BatchSelector from '../../components/SchoolFees/BatchSelector';

const FeesBatch = () => {
    const [activeTab, setActiveTab] = useState('batchListing'); // Manage active tab
   
   

    return (
       
            <div className='card'>
            <div className="card-body">
                <ul className="nav nav-tabs card-header-tabs">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'batchListing' ? 'active' : ''}`}
                            onClick={() => setActiveTab('batchListing')}
                        >
                            Batch Selector
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'addBatch' ? 'active' : ''}`}
                            onClick={() => setActiveTab('addBatch')}
                        >
                            New Batch
                        </button>
                    </li>
                </ul>
                {activeTab === 'batchListing' && (
                    <>
                        
                        <BatchSelector />
                    </>
                )}

                {activeTab === 'addBatch' && (
                    <>
                       <NewBatch />

                    
                    </>
                )}
            </div>
            </div>
    );
};

export default FeesBatch;
